import { formatDate } from '@angular/common';
import { MyLog } from '@common/common';
import dayjs, { Dayjs, ManipulateType } from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  ensureArray,
  isAnyString,
  isJsObject,
  objectKeys,
  parseDec,
  to2Digits,
  trimString,
} from './utils';

dayjs.extend(customParseFormat);

export function setNumberToTimeIfInteger(value: any) {
  return Number.isFinite(value) ? numberToTime(value) : value;
}

export function dateObjectFor(d: Date) {
  return dayjs(d).locale('de', {
    weekStart: 1,
  });
}

export function dateObjectForNow() {
  return dayjs().locale('de', {
    weekStart: 1,
  });
}

export function myFormatDate(d: Date, format: string) {
  while (format && format.indexOf('D') >= 0) {
    format = format.replace('D', 'd');
  }
  return formatDate(d, format, 'de-DE');
  //return dateObjectFor(d).format(format);
  //return moment(d).format(format);
}

export function subtractDate(d: Date, amount: number, unit: ManipulateType) {
  return dateObjectFor(d).subtract(amount, unit).toDate();
}

function shouldEndWith(s: string, end: string) {
  if (s.indexOf('s') !== s.length - 1) {
    s += end;
  }
  return s;
}

function endOf(val: any, unit: string) {
  //val = val ? moment(val) : moment();
  val = val ? dateObjectFor(val) : dateObjectForNow();
  return val.endOf(unit).toDate();
}

function startOf(val: any, unit: string) {
  //val = val ? moment(val) : moment();
  val = val ? dateObjectFor(val) : dateObjectForNow();
  return val.startOf(unit).toDate();
}

const dateMapping: any = {
  monthstart: [startOf, 'month'],
  monthend: [endOf, 'month'],
  weekstart: [startOf, 'week'],
  weekend: [endOf, 'week']
};

export function getDateFor(ops: string, startDate: any, curDate?: Date) {
  const opsArr = ops
    .split(',')
    .map((e: string) => {
      return e.trim();
    })
    .filter((e: string) => {
      return !!e;
    });
  /*
  moment.updateLocale('de', {
    week: {
      dow: 1, // Monday is the first day of the week.
    }
  });
  */
  let val = null;

  if (!curDate) {
    curDate = new Date();
  }

  for (let o of opsArr) {
    let found = false;
    if (o) {
      found = true;

      if (dateMapping[o]) {
        let m = dateMapping[o];
        val = m[0](val, m[1]);
      } else {
        switch (o) {
          case 'none':
            val = null;
            break;
          case 'now':
            val = curDate;
            break;
          /*
        case 'monthstart':
          val = startOf(val, 'month');
          break;
        case 'monthend':
          val = endOf(val, 'month');
          break;
        case 'weekstart':
          val = startOf(val, 'week');
          break;
        case 'weekend':
          val = endOf(val, 'week');
          break;
          */
          case 'start':
            val = startDate;
            break;
          default:
            found = false;
        }
      }
    }

    if (!found) {
      let num: any, unit: any;

      for (let u of ['months', 'days', 'day', 'month']) {
        let idx = o.indexOf(u);
        if (idx > 0) {
          let n = parseDec(o.substring(0, idx));
          if (!isNaN(n)) {
            num = n;
            unit = shouldEndWith(u, 's');
            break;
          }
        }
      }
      if (unit && Number.isInteger(num)) {
        if (val) {
          found = true;
          val = dateObjectFor(val);
          val = num > 0 ? val.add(num, unit) : val.subtract(-num, unit);
          val = val.toDate();
        }
      }
    }
    if (!found) {
      console.error('Operation not found:', o);
    }
  }

  return val;
}

export function tryParseTime(val: any) {
  val = trimString(val).replace(':', '');

  if (val === '') {
    return val;
  }

  let nVal = parseDec(val);

  if (!isNaN(nVal) && '' + nVal == '' + val && nVal >= 0 && nVal < 2460) {
    return numberToTime(nVal);
  }
  return null;
}

export function addMonths(d: Date, months: number) {
  return dayjs(d).add(months, 'month').toDate();
  //return moment(d).add(months, 'month').toDate();
}

export const dayNames: string[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const jsDayNames: string[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const weekDayNames: any = {
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
};


export function toRequestDate(d: any) {
  if (d) {
    if (typeof d === 'string' && isValidDate(d)) {
      return d;
    }
    if (d instanceof Date) {
      return dateToStr(d);
    }
  }
  return '';
}

export interface ValidateTimeResult {
  input: any;
  success: boolean;
  date?: Date | null;
}

export function validateTime(time: any): ValidateTimeResult {
  if (time instanceof Date) {
    return {
      input: time,
      success: true,
      date: time
    }
  }
  const result: ValidateTimeResult = {
    input: time,
    success: false,
    date: null
  };

  if (typeof time === 'string') {
    let valid = false;
    let d = new Date();
    let parts = time.split(':');
    let h = parseInt(parts[0], 10);
    let assigned = false;
    if (Number.isFinite(h) && h >= 0 && h <= 23) {
      d.setHours(h);
      assigned = true;
      valid = true;
    }
    if (parts.length > 1) {
      h = parseInt(parts[1], 10);
      if (Number.isFinite(h) && h >= 0 && h <= 59) {
        d.setMinutes(h);
        valid = true;
      } else {
        valid = false;
      }
    }
    if (assigned && valid) {
      result.date = d;
      result.success = true;
    }
  }
  return result;
}

export function toRequestTime(d: any): number | null {
  if (d instanceof Date) {
    return d.getHours() * 100 + d.getMinutes();
  }
  return null;
}

export function numberToTime(num: number) {
  return Number.isFinite(num)
    ? to2Digits(Math.floor(num / 100)) + ':' + to2Digits(num % 100)
    : '';
}

export function toDateForTimepicker(time: any) {
  if (Number.isFinite(time)) {
    const h = Math.floor(time / 100);
    const m = Math.floor(time % 100);
    const d = new Date();
    d.setHours(h);
    d.setMinutes(m);
    d.setSeconds(0);
    return d;
  }
  return null;
}

export function dateToStr(d: Date, addHM = false) {
  const year = d.getFullYear();
  let m: string | number = to2Digits(d.getMonth() + 1);
  let day: string | number = to2Digits(d.getDate());
  let res = [day, m, year].join('.');

  if (addHM) {
    let h: string = to2Digits(d.getHours());
    let m: string = to2Digits(d.getMinutes());
    res += '_' + h + '.' + m;
  }
  return res;
}

function fromStr(val: any, mode: string) {
  if (typeof val === 'string') {
    return strToDate(val, mode);
  }
  if (val instanceof Date) {
    return val;
  }
  return null;
}

function diffBy(d1: any, d2: any, f: string) {
  return d1[f]() !== d2[f]();
}

export function areDifferentValues(value1: any, value2: any, mode: string) {
  if (!value1) {
    value1 = '';
  }
  if (!value2) {
    value2 = '';
  }
  if (value1 === value2) {
    return true;
  }

  let d1: Date | null = fromStr(value1, mode);
  let d2: Date | null = fromStr(value2, mode);

  if (d1 && d2) {
    return (diffBy(d1, d2, 'getFullYear') ||
      diffBy(d1, d2, 'getMonth') ||
      diffBy(d1, d2, 'getDate')
    );
  }
  return true;
}

function dateParse(s: any, format: string) {
  return dayjs(s, format);
}

export function strToDate(value: any, acceptTill = '') {
  if (isAnyString(value)) {
    const s = value.trim();

    const p = s
      .split('.')
      .map((item: any) => {
        if (item) {
          return parseDec(item);
        }
        return NaN;
      })
      .filter((item: any) => {
        return Number.isFinite(item);
      });

    const current = new Date();
    //let momentDate: moment.Moment | null = null;
    let momentDate: Dayjs | null = null;

    if (
      3 === p.length &&
      p[0] >= 1 &&
      p[0] <= 31 &&
      p[1] >= 1 &&
      p[1] <= 12 &&
      p[2] >= 1850 &&
      p[2] < 10000
    ) {
      const s = to2Digits(p[0]) + '.' + to2Digits(p[1]) + '.' + p[2];
      momentDate = dateParse(s, 'DD.MM.YYYY'); //moment(s, 'DD.MM.YYYY');
    }

    if (!momentDate && p.length < 3) {
      switch (acceptTill) {
        case 'day':
          if (p.length < 3 && p[0] >= 1 && p[0] <= 31) {
            let m: number = 0;
            if (2 === p.length) {
              if (p[1] >= 1 && p[1] <= 12) {
                m = p[1];
              }
            } else {
              m = current.getMonth() + 1;
            }

            if (m) {
              const s = to2Digits(p[0]) + '.' +
                to2Digits(m) + '.' + current.getFullYear();
              momentDate = dateParse(s, 'DD.MM.YYYY');
            }
          }
          break;
        case 'month':
          if (
            2 === p.length &&
            p[0] >= 1 &&
            p[0] <= 31 &&
            p[1] >= 1 &&
            p[1] <= 12
          ) {
            const s = to2Digits(p[0]) + '.' + to2Digits(p[1]) + '.' + current.getFullYear();
            momentDate = dateParse(s, 'DD.MM.YYYY');
          }
          break;
      }
    }
    MyLog.log('Moment:', value, momentDate)

    if (momentDate && momentDate.isValid()) {
      const res = momentDate.toDate();
      res.setHours(0);
      res.setMinutes(0);
      res.setSeconds(1);
      return res;
    }
  }
  return null;
}

export interface ValidateDateResult {
  invalid?: boolean;
  notSet?: boolean;
  value?: string;
}

export function validateDate(d: any): ValidateDateResult {
  if (!d) {
    return {
      notSet: true,
    };
  }

  if (d instanceof Date) {
    const val = [d.getDate(), (d.getMonth() + 1), d.getFullYear()].join('.');
    return {
      value: val,
    };
  }

  if (typeof d === 'string') {
    const res = strToDate(d);
    if (res) {
      const val = dateToStr(res);
      return {
        value: val,
      };
    }
  }
  //
  return {
    invalid: true,
  };
}

export function isValidDate(d: any) {
  if (d instanceof Date) {
    return dateObjectFor(d).isValid();
    //return moment(d).isValid();
  }
  if (typeof d === 'string') {
    const res = strToDate(d);
    return !!res;
  }
  return false;
}

function isSameOrAfter(
  prevDate: Dayjs,
  afterDate: Dayjs,
  type: ManipulateType
) {
  return prevDate.isSame(afterDate, type) || prevDate.isAfter(afterDate, type);
}




